import React from "react";
import Search from "./Search";
import Users from "./Users";

const Home = () => {
  return (
    <>
      <Search />
      <Users />
    </>
  );
};

export default Home;
